import React, { useEffect, useContext, useState } from 'react';
import { NavContext, HttpMethods, FetchContext, ApiRoutes, ToastContext } from '../../../contexts';
import { ApplicationRoles } from '../../../../helpers';
import { Button, Dialog } from '@material-ui/core';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise/dist/styles/ag-grid.css';
import 'ag-grid-enterprise/dist/styles/ag-theme-balham.css';
import * as moment from "moment";
import { makeStyles } from '@material-ui/core/styles';
import { MyProjectsContext } from '../MyProjectsContext';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    overflow: 'hidden'
  },
  author: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(1)
  },
  table: {

  },
  header: {
    fontSize: '1rem'
  },
  gridContainer:{
    height: 'calc(100% - 67px)'
  }
}));

let gridApi = null;
let gridColumnApi = null;

export default function LogsDialog(props) {
  const { fetchAuthorized } = useContext(FetchContext);
  const classes = useStyles();

  const [isDialog, setIsDialog] = useState(false);
  const [selectedLogs, setSelectedLogs] = useState(null);
  const [lookUpData, setLookUpData] = useState(null);

  const {
    state,
    getProjectAsync,
    setRestoredProjectAsync
  } = useContext(MyProjectsContext);

  const {
    project,
    isLoadingProject
  } = state;

  const getLookupDataAsync = async () => {
    try {
      const getLookupDataApi = await fetchAuthorized(ApiRoutes.Data.GetLookupData({ includeDeleted: true }),
      {
        method: HttpMethods.GET
      });

      const lookUpData = await getLookupDataApi.json();
      setLookUpData(lookUpData);
    }

    catch (ex) {
      console.error(ex);
      console.error(ex.details);
    }
  }

  useEffect(() => {
    getLookupDataAsync();
  }, [])

  useEffect(() => {
    if (!isLoadingProject && gridApi)
      gridApi.showNoRowsOverlay();
  }, [isLoadingProject])

  function closeDialog() {
    gridApi.destroy();
    setSelectedLogs(null);
    setIsDialog(false);
  }

  //variables must be inside PageContent, otherwise they won't get reset after exiting the page. They are objects and not pure numbers because only object properties can be changed as function parameters
  let sapInitiativeHistory = [];
  let sapInitiativeChanges = { arrayIndex: 0 };
  let domainHistory = [];
  let domainChanges = { arrayIndex: 0 };
  let subDomainHistory = [];
  let subDomainChanges = { arrayIndex: 0 };
  let prNameHistory = [];
  let prNameChanges = { arrayIndex: 0 };
  let itOwnerHistory = [];
  let itOwnerChanges = { arrayIndex: 0 };
  let subOwnerHistory = [];
  let subOwnerChanges = { arrayIndex: 0 };
  let businessOwnerHistory = [];
  let businessOwnerChanges = { arrayIndex: 0 };
  let targetHistory = [];
  let targetChanges = { arrayIndex: 0 };
  let customerHistory = [];
  let customerChanges = { arrayIndex: 0 };
  let subCustomerHistory = [];
  let subCustomerChanges = { arrayIndex: 0 };
  let goalHistory = [];
  let goalChanges = { arrayIndex: 0 };
  let timingHistory = [];
  let timingChanges = { arrayIndex: 0 };
  let priorityHistory = [];
  let priorityChanges = { arrayIndex: 0 };
  let natureHistory = [];
  let natureChanges = { arrayIndex: 0 };
  let investmentHistory = [];
  let investmentChanges = { arrayIndex: 0 };
  let mandatoryHistory = [];
  let mandatoryChanges = { arrayIndex: 0 };
  let methodologyHistory = [];
  let methodologyChanges = { arrayIndex: 0 };
  let digitalHistory = [];
  let digitalChanges = { arrayIndex: 0 };
  let prApprovalHistory = [];
  let prApprovalChanges = { arrayIndex: 0 };
  let prPhaseHistory = [];
  let prPhaseChanges = { arrayIndex: 0 };
  let progressHistory = [];
  let progressChanges = { arrayIndex: 0 };
  let estimationHistory = [];
  let estimationChanges = { arrayIndex: 0 };
  let prKOHistory = [];
  let prKOChanges = { arrayIndex: 0 };
  let connectedCostsHistory = [];
  let connectedCostsChanges = { arrayIndex: 0 };
  let hwInvestmentsHistory = [];
  let hwInvestmentsChanges = { arrayIndex: 0 };
  let l01History = [];
  let l01Changes = { arrayIndex: 0 };
  let l01D1History = [];
  let l01D1Changes = { arrayIndex: 0 };
  let l01D2History = [];
  let l01D2Changes = { arrayIndex: 0 };
  let l01D3History = [];
  let l01D3Changes = { arrayIndex: 0 };
  let l03History = [];
  let l03Changes = { arrayIndex: 0 };
  let l03D1History = [];
  let l03D1Changes = { arrayIndex: 0 };
  let l03D2History = [];
  let l03D2Changes = { arrayIndex: 0 };
  let l03D3History = [];
  let l03D3Changes = { arrayIndex: 0 };
  let l06History = [];
  let l06Changes = { arrayIndex: 0 };
  let l06D1History = [];
  let l06D1Changes = { arrayIndex: 0 };
  let l06D2History = [];
  let l06D2Changes = { arrayIndex: 0 };
  let l06D3History = [];
  let l06D3Changes = { arrayIndex: 0 };
  let l12History = [];
  let l12Changes = { arrayIndex: 0 };
  let l12D1History = [];
  let l12D1Changes = { arrayIndex: 0 };
  let l12D2History = [];
  let l12D2Changes = { arrayIndex: 0 };
  let l12D3History = [];
  let l12D3Changes = { arrayIndex: 0 };
  let commitmentHistory = [];
  let commitmentChanges = { arrayIndex: 0 };
  let actualHistory = [];
  let actualChanges = { arrayIndex: 0 };
  let rebillingHistory = [];
  let rebillingChanges = { arrayIndex: 0 };
  let releaseDateHistory = [];
  let releaseDateChanges = { arrayIndex: 0 };
  let prLifeHistory = [];
  let prLifeChanges = { arrayIndex: 0 };
  let prStatusHistory = [];
  let prStatusChanges = { arrayIndex: 0 };
  let portfolioHistory = [];
  let portfolioChanges = { arrayIndex: 0 };
  let responsibilityHistory = [];
  let responsibilityChanges = { arrayIndex: 0 };
  let isLockedHistory = [];
  let isLockedChanges = { arrayIndex: 0 };
  let notesHistory = [];
  let notesChanges = { arrayIndex: 0 };

  function isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  const [defaultColDef, setDefaultColDef] = useState({
    filter: 'agTextColumnFilter',
    sortable: true,
    editable: false,
    cellStyle: { color: 'grey'/*, 'background-color': 'green'*/ },
    resizable: true,
    headerCheckboxSelection: isFirstColumn,
    checkboxSelection: isFirstColumn
  });

  function highlightCell(params, changedField) {
    let numberValue = null;
    if ((params || params == 0) && params.colDef.field !== "sap initiative" && params.colDef.field !== "isLocked") {
      const formatter = new Intl.NumberFormat('en-US', {//it-IT
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });

      if (Number(params.value) || params.value === 0) {
        const checkValue = params.value == 0 ? formatter.format(0) : formatter.format(params.value);
        numberValue = params.value || params.value === 0 ? checkValue : "";
      }
    }

    let isChanged = false;
    if (params.rowIndex !== project.dataChanges.length - 1) {
      if (changedField !== "Author" && changedField !== "LastDate") {
				if (params.data.changed.changeItems){
          params.data.changed.changeItems.map(field => {
            if (field.targetProperty == changedField)
              isChanged = true;
          });
        }
			}
      else {
        if (changedField === "Author") {
          const previousAuthor = project.dataChanges[params.rowIndex + 1].doerFullName;
          const currentAuthor = project.dataChanges[params.rowIndex].doerFullName;
          if (previousAuthor !== currentAuthor)
            isChanged = true;
        }
        /*else if (changedField === "LastDate"){
          const previousDate = project.dataChanges[params.rowIndex+1].changeDate;
          const currentDate = project.dataChanges[params.rowIndex].changeDate;
          if (previousDate !== currentDate)
            isChanged = true;
        }*/
      }
    }

    //the string " " doesn't occupy any space so the yellow background can't be seen, instead the unicode code occupies space (https://graphemica.com)
    return `<div style="height: 100%; width: 100%; background-color: ${isChanged ? 'yellow' : 'transparent'};">${params.value === null || params.value === "" || params.value == "@null" ? "&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0&#x00A0" : numberValue ? numberValue : params.value}</div>`;
  }

  const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);

  const [columnDefs, setColumnDefs] = useState(null);
  useEffect(() => {
    if (project !== null && lookUpData !== null) {
      addBreadcrumbToken(`${project.projectId} - ${project.name}`);

      function getDataValue(dbProject, lookupField, extraField) {
        let value = null;
        if (lookupField.length > 0) {
          if (extraField) {
            let cache = {};
            const doubles = [];
            for (let i = 0; i < lookupField.length; i++) {
              if (cache[lookupField[i].title] === true)
                doubles.push(lookupField[i].title);
              else
                cache[lookupField[i].title] = true;
            }

            const doubleObjects = [];
            lookupField.map(lookupData => {
              doubles.map(double => {
                if (lookupData.title === double)
                  doubleObjects.push(lookupData);
              })
            });

            doubleObjects.map(double => {
              if (double.id === dbProject)
                value = double.title + " " + (extraField === "Rebilling" || extraField === "Release Date" ? double.customId : double.code);
            });

            if (!value)
              lookupField.map(lookupData => {
                if (dbProject === lookupData.id)
                  value = lookupData.title;
              });
          }

          else
            lookupField.map(lookupData => {
              if (dbProject === lookupData.id)
                value = lookupData.title;
            });
        }
        return value;
      }

      const projectsData = [];

      if (project && project.dataChanges && project.dataChanges.length > 0) {
        const projectHistory = project.dataChanges.reverse();

        collectChanges(sapInitiativeHistory, "SapInitiative");
        collectChanges(domainHistory, "DomainId");
        collectChanges(subDomainHistory, "SubDomainId");
        collectChanges(prNameHistory, "Name");
        collectChanges(itOwnerHistory, "OwnerFullName");
        collectChanges(subOwnerHistory, "SubOwnerFullName");
        collectChanges(businessOwnerHistory, "BusinessOwner");
        collectChanges(targetHistory, "TargetId");
        collectChanges(customerHistory, "CustomerId");
        collectChanges(subCustomerHistory, "SubCustomerId");
        collectChanges(goalHistory, "GoalId");
        collectChanges(timingHistory, "TimingId");
        collectChanges(priorityHistory, "PriorityId");
        collectChanges(natureHistory, "NatureId");
        collectChanges(investmentHistory, "InvestmentMixId");
        collectChanges(mandatoryHistory, "MandatoryId");
        collectChanges(methodologyHistory, "MethodologyId");
        collectChanges(digitalHistory, "DigitalId");
        collectChanges(prApprovalHistory, "ProjectApprovalId");
        collectChanges(prPhaseHistory, "ProjectPhaseId");
        collectChanges(progressHistory, "Progress");
        collectChanges(estimationHistory, "Estimation");
        collectChanges(prKOHistory, "ProjectKO");
        collectChanges(connectedCostsHistory, "ConnectedCosts");
        collectChanges(hwInvestmentsHistory, "HardwareConnectedInvestments");
        collectChanges(l01History, "L01");
        collectChanges(l01D1History, "L01D1");
        collectChanges(l01D2History, "L01D2");
        collectChanges(l01D3History, "L01D3");
        collectChanges(l03History, "L03");
        collectChanges(l03D1History, "L03D1");
        collectChanges(l03D2History, "L03D2");
        collectChanges(l03D3History, "L03D3");
        collectChanges(l06History, "L06");
        collectChanges(l06D1History, "L06D1");
        collectChanges(l06D2History, "L06D2");
        collectChanges(l06D3History, "L06D3");
        collectChanges(l12History, "L12");
        collectChanges(l12D1History, "L12D1");
        collectChanges(l12D2History, "L12D2");
        collectChanges(l12D3History, "L12D3");
        collectChanges(commitmentHistory, "Committment");
        collectChanges(actualHistory, "Actual");
        collectChanges(rebillingHistory, "RebillingId");
				collectChanges(releaseDateHistory, "ReleaseDateId");
        collectChanges(prLifeHistory, "ProjectLifeId");
        collectChanges(prStatusHistory, "ProjectStatusId");
        collectChanges(portfolioHistory, "PortfolioMixId");
        collectChanges(responsibilityHistory, "ResponsibilityCenterId");
        collectChanges(isLockedHistory, "IsLocked");
        collectChanges(notesHistory, "Notes");

        function collectChanges(array, column) {
          projectHistory.map((change, index) => {
            change.changeItems && change.changeItems.map(field => {
              if (field.targetProperty == column) {
                const object = { changing: index, originalValue: field.originalValue, changedValue: field.changedValue };
                array.push(object);
              }
            });
          });
        }

        projectHistory.map((change, index) => {
          let domainString = null;
          let subDomainString = null;
          let timingString = null;
          let customerString = null;
          let subCustomerString = null;
          let goalString = null;
          let priorityString = null;
          let natureString = null;
          let investmentString = null;
          let mandatoryString = null;
          let methodologyString = null;
          let digitalString = null;
          let prLivesString = null;
          let prStatusString = null;
          let portfolioString = null;
          let responsibilityString = null;
          let prApprovalString = null;
          let prPhaseString = null;
          let targetString = null;
          let rebillingString = null;
					let releaseDateString = null;

					change.changeItems && change.changeItems.map(field => {
            domainString = getDataValue(field.targetProperty == "DomainId" ? field.changedValue : project.domainId, lookUpData.domains);

            subDomainString = getDataValue(field.targetProperty == "SubDomainId" ? field.changedValue : project.subDomainId, lookUpData.subDomains);

            timingString = getDataValue(field.targetProperty == "TimingId" ? field.changedValue : project.timingId, lookUpData.timings);

            customerString = getDataValue(field.targetProperty == "CustomerId" ? field.changedValue : project.customerId, lookUpData.customers);

            subCustomerString = getDataValue(field.targetProperty == "SubCustomerId" ? field.changedValue : project.subCustomerId, lookUpData.subCustomers);

            goalString = getDataValue(field.targetProperty == "GoalId" ? field.changedValue : project.goalId, lookUpData.goals);

            priorityString = getDataValue(field.targetProperty == "PriorityId" ? field.changedValue : project.priorityId, lookUpData.priorities);

            natureString = getDataValue(field.targetProperty == "NatureId" ? field.changedValue : project.natureId, lookUpData.natures);

            investmentString = getDataValue(field.targetProperty == "InvestmentMixId" ? field.changedValue : project.investmentMixId, lookUpData.investmentMixes);

            mandatoryString = getDataValue(field.targetProperty == "MandatoryId" ? field.changedValue : project.mandatoryId, lookUpData.mandatories);

            methodologyString = getDataValue(field.targetProperty == "MethodologyId" ? field.changedValue : project.methodologyId, lookUpData.methodologies);

            digitalString = getDataValue(field.targetProperty == "DigitalId" ? field.changedValue : project.digitalId, lookUpData.digitals);

            prLivesString = getDataValue(field.targetProperty == "ProjectLifeId" ? field.changedValue : project.projectLifeId, lookUpData.projectLives);

            prStatusString = getDataValue(field.targetProperty == "ProjectStatusId" ? field.changedValue : project.projectStatusId, lookUpData.projectStatus);

            portfolioString = getDataValue(field.targetProperty == "PortfolioMixId" ? field.changedValue : project.portfolioMixId, lookUpData.portfolioMixes);

            responsibilityString = getDataValue(field.targetProperty == "ResponsibilityCenterId" ? field.changedValue : project.responsibilityCenterId, lookUpData.responsibilityCenters);

            prApprovalString = getDataValue(field.targetProperty == "ProjectApprovalId" ? field.changedValue : project.projectApprovalId, lookUpData.projectApprovals);

            prPhaseString = getDataValue(field.targetProperty == "ProjectPhaseId" ? field.changedValue : project.projectPhaseId, lookUpData.projectPhases);

            rebillingString = getDataValue(field.targetProperty == "RebillingId" ? field.changedValue : project.rebillingId, lookUpData.rebillings, "Rebilling");

            targetString = getDataValue(field.targetProperty == "TargetId" ? field.changedValue : project.targetId, lookUpData.targets);

						releaseDateString = getDataValue(field.targetProperty == "ReleaseDateId" ? field.changedValue : project.releaseDateId, lookUpData.releaseDates, "Release Date");
					});

          const allColumns = [
            {
              headerName: 'Change Id',
              field: 'changed.changeId',
              filter: 'agNumberColumnFilter',
              width: 100
            },
            {
              headerName: 'Last Modified Date',
              field: 'last modified date',
              cellRenderer: params => highlightCell(params, "LastDate"),
              comparator: dateComparator,
              filter: 'agDateColumnFilter',
              filterParams: {
                comparator: function (filterLocalDateAtMidnight, cellValue) {
                  const dateParts = cellValue.split(' ')[0].split('/');

                  const cellDate = new Date(
                    Number(dateParts[2]),
                    Number(dateParts[1]) - 1,
                    Number(dateParts[0])
                  );

                  if (filterLocalDateAtMidnight.getTime() === cellDate.getTime())
                    return 0;

                  if (cellDate < filterLocalDateAtMidnight)
                    return -1;

                  if (cellDate > filterLocalDateAtMidnight)
                    return 1;
                }
              }
            },
            {
              headerName: 'Last Modified By',
              field: 'last modified by',
              cellRenderer: params => highlightCell(params, "Author")
            },
            {
              headerName: 'Year',
              field: 'year',
              filter: 'agNumberColumnFilter',
              hide: true,
              width: 80
            },
            {
              headerName: 'ID',
              field: 'id',
              filter: 'agNumberColumnFilter',
              width: 80
            },
            {
              headerName: 'SAP Initiative',
              field: 'sap initiative',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "SapInitiative")
            },
            {
              headerName: 'Domain',
              field: 'domain',
              filter: 'agSetColumnFilter',
              cellRenderer: params => highlightCell(params, "DomainId")
            },
            {
              headerName: 'Sub Domain',
              field: 'sub domain',
              cellRenderer: params => highlightCell(params, "SubDomainId")
            },
            {
              headerName: 'Project Name',
              field: 'project name',
              cellRenderer: params => highlightCell(params, "Name")
            },
            {
              headerName: "IT Owner",
              field: "it owner",
              filter: 'agSetColumnFilter',
              cellRenderer: params => highlightCell(params, "OwnerFullName")
            },
            {
              headerName: "Sub Owner",
              field: "sub owner",
              filter: 'agSetColumnFilter',
              cellRenderer: params => highlightCell(params, "SubOwnerFullName")
            },
            {
              headerName: 'Business Owner',
              field: 'business owner',
              cellRenderer: params => highlightCell(params, "BusinessOwner")
            },
            {
              headerName: 'Target region',
              field: 'target region',
              cellRenderer: params => highlightCell(params, "TargetId")
            },
            {
              headerName: 'Customer',
              field: 'customer',
              filter: 'agSetColumnFilter',
              cellRenderer: params => highlightCell(params, "CustomerId")
            },
            {
              headerName: 'Sub Customer',
              field: 'sub-customer',
              cellRenderer: params => highlightCell(params, "SubCustomerId")
            },
            {
              headerName: 'Goal',
              field: 'goal',
              cellRenderer: params => highlightCell(params, "GoalId")
            },
            {
              headerName: 'Timing',
              field: 'timing',
              filter: 'agSetColumnFilter',
              cellRenderer: params => highlightCell(params, "TimingId")
            },
            {
              headerName: 'Priority',
              field: 'priority',
              cellRenderer: params => highlightCell(params, "PriorityId")
            },
            {
              headerName: 'Nature',
              field: 'nature',
              filter: 'agSetColumnFilter',
              cellRenderer: params => highlightCell(params, "NatureId")
            },
            {
              headerName: 'Investment mix',
              field: 'investment mix',
              cellRenderer: params => highlightCell(params, "InvestmentMixId")
            },
            {
              headerName: 'Mandatory',
              field: 'mandatory',
              filter: 'agSetColumnFilter',
              cellRenderer: params => highlightCell(params, "MandatoryId")
            },
            {
              headerName: 'Methodology',
              field: 'methodology',
              cellRenderer: params => highlightCell(params, "MethodologyId")
            },
            {
              headerName: 'Digital spending',
              field: 'digital',
              cellRenderer: params => highlightCell(params, "DigitalId")
            },
            {
              headerName: 'Project Approval',
              field: 'project approval',
              cellRenderer: params => highlightCell(params, "ProjectApprovalId")
            },
            {
              headerName: 'Project Phase',
              field: 'project phase',
              cellRenderer: params => highlightCell(params, "ProjectPhaseId")
            },
            {
              headerName: 'Progress',
              field: 'progress',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "Progress")
            },
            {
              headerName: 'Estimation',
              field: 'estimation',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "Estimation")
            },
            {
              headerName: 'Project KO value',
              field: 'project ko',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "ProjectKO")
            },
            {
              headerName: 'Connected Costs',
              field: 'connected costs',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "ConnectedCosts")
            },
            {
              headerName: 'H/W Connected Investments',
              field: 'h/w connected investments',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "HardwareConnectedInvestments")
            },
            {
              headerName: 'L01',
              field: 'l01',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L01")
            },
            {
              headerName: 'L01-D1',
              field: 'l01-d1',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L01D1")
            },
            {
              headerName: 'L01-S1',
              field: 'l01-s1',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l01) + Number(data[`l01-d1`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L01-D2',
              field: 'l01-d2',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L01D2")
            },
            {
              headerName: 'L01-S2',
              field: 'l01-s2',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l01) + Number(data[`l01-d1`]) + Number(data[`l01-d2`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L01-D3',
              field: 'l01-d3',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L01D3")
            },
            {
              headerName: 'L01-RO',
              field: 'l01-ro',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l01) + Number(data[`l01-d1`]) + Number(data[`l01-d2`]) + Number(data[`l01-d3`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L03',
              field: 'l03',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L03")
            },
            {
              headerName: 'L03-D1',
              field: 'l03-d1',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L03D1")
            },
            {
              headerName: 'L03-S1',
              field: 'l03-s1',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l03) + Number(data[`l03-d1`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L03-D2',
              field: 'l03-d2',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L03D2")
            },
            {
              headerName: 'L03-S2',
              field: 'l03-s2',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l03) + Number(data[`l03-d1`]) + Number(data[`l03-d2`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L03-D3',
              field: 'l03-d3',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L03D3")
            },
            {
              headerName: 'L03-RO',
              field: 'l03-ro',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l03) + Number(data[`l03-d1`]) + Number(data[`l03-d2`]) + Number(data[`l03-d3`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L06',
              field: 'l06',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L06")
            },
            {
              headerName: 'L06-D1',
              field: 'l06-d1',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L06D1")
            },
            {
              headerName: 'L06-S1',
              field: 'l06-s1',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l06) + Number(data[`l06-d1`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L06-D2',
              field: 'l06-d2',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L06D2")
            },
            {
              headerName: 'L06-S2',
              field: 'l06-s2',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l06) + Number(data[`l06-d1`]) + Number(data[`l06-d2`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L06-D3',
              field: 'l06-d3',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L06D3")
            },
            {
              headerName: 'L06-RO',
              field: 'l06-ro',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l06) + Number(data[`l06-d1`]) + Number(data[`l06-d2`]) + Number(data[`l06-d3`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L12',
              field: 'l12',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L12")
            },
            {
              headerName: 'L12-D1',
              field: 'l12-d1',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L12D1")
            },
            {
              headerName: 'L12-S1',
              field: 'l12-s1',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l12) + Number(data[`l12-d1`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L12-D2',
              field: 'l12-d2',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L12D2")
            },
            {
              headerName: 'L12-S2',
              field: 'l12-s2',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l12) + Number(data[`l12-d1`]) + Number(data[`l12-d2`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'L12-D3',
              field: 'l12-d3',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "L12D3")
            },
            {
              headerName: 'L12-RO',
              field: 'l12-ro',
              filter: 'agNumberColumnFilter',
              hide: true,
              valueGetter: 'Number(data.l12) + Number(data[`l12-d1`]) + Number(data[`l12-d2`]) + Number(data[`l12-d3`])',
              cellRenderer: params => highlightCell(params, "")
            },
            {
              headerName: 'Commitment',
              field: 'commitment',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "Committment")
            },
            {
              headerName: 'Actual',
              field: 'actual',
              filter: 'agNumberColumnFilter',
              cellRenderer: params => highlightCell(params, "Actual")
            },
            {
              headerName: 'Rebilling',
              field: 'rebilling',
              cellRenderer: params => highlightCell(params, "RebillingId")
            },
            {
              headerName: 'Release Date',
              field: 'release date',
              cellRenderer: params => highlightCell(params, "ReleaseDateId")
						},
            {
              headerName: 'Project Life',
              field: 'project life',
              cellRenderer: params => highlightCell(params, "ProjectLifeId")
            },
            {
              headerName: 'Project Status',
              field: 'project status',
              cellRenderer: params => highlightCell(params, "ProjectStatusId")
            },
            {
              headerName: 'Portfolio Mix',
              field: 'portfolio mix',
              cellRenderer: params => highlightCell(params, "PortfolioMixId")
            },
            {
              headerName: 'Responsibility Center',
              field: 'responsibility center',
              cellRenderer: params => highlightCell(params, "ResponsibilityCenterId")
            },
            {
              headerName: 'Locked',
              field: 'isLocked',
              cellRenderer: params => highlightCell(params, "IsLocked")
            },
            {
              headerName: 'Notes',
              field: 'notes',
              cellRenderer: params => highlightCell(params, "Notes")
            },
            {
              headerName: 'Changed',
              field: 'changed',
              hide: true,
              width: 0,
              filter: false,
              cellRenderer: () => { return `<div style="display: none};"></div>`; }
            }
          ];

          //cannot use directly setColumnDefs(allColumns)
          if (gridApi)
            gridApi.setColumnDefs(allColumns);

          function setChangedValues(oldValues, changes, lookUpOptions, extraField) {
            let value = null;

            if (changes.arrayIndex < oldValues.length) {
              if (index < oldValues[changes.arrayIndex].changing)
                value = oldValues[changes.arrayIndex].changedValue;

              else if (oldValues[changes.arrayIndex].changing === index) {
                value = oldValues[changes.arrayIndex].changedValue;

                if (changes.arrayIndex + 1 < oldValues.length)
                  changes.arrayIndex += 1;
              }

              else
                value = oldValues[changes.arrayIndex].originalValue;
            }

            let lookupValue = null;

            if (lookUpOptions)
              lookupValue = getDataValue(value, lookUpOptions, extraField);

            return lookupValue ? lookupValue : value;
          }

          let updateDateLocal = null;
					if (change.changeDate) {
						const checkDate = change.changeDate.indexOf('Z') !== -1 ? change.changeDate : change.changeDate + "Z";
						const updateDate = new Date(checkDate);
						const updateDateUTC = new Date(updateDate.setHours(updateDate.getHours()));
						updateDateLocal = moment(updateDateUTC).format("DD/MM/YYYY H:mm:ss");
					}

          projectsData.push({
            'id': project.projectId,
            'project name': prNameHistory.length > 0 ? setChangedValues(prNameHistory, prNameChanges) : project.name,
            'it owner': itOwnerHistory.length > 0 ? setChangedValues(itOwnerHistory, itOwnerChanges) : project.ownerFullName,
            'sub owner': subOwnerHistory.length > 0 ? setChangedValues(subOwnerHistory, subOwnerChanges) : project.subOwnerFullName,
            'business owner': businessOwnerHistory.length > 0 ? setChangedValues(businessOwnerHistory, businessOwnerChanges) : project.businessOwner,
            'year': project.year,
            'sap initiative': sapInitiativeHistory.length > 0 ? setChangedValues(sapInitiativeHistory, sapInitiativeChanges) : project.sapInitiative,
            'domain': domainHistory.length > 0 ? setChangedValues(domainHistory, domainChanges, lookUpData.domains) : domainString,
            'sub domain': subDomainHistory.length > 0 ? setChangedValues(subDomainHistory, subDomainChanges, lookUpData.subDomains) : subDomainString,
            'target region': targetHistory.length > 0 ? setChangedValues(targetHistory, targetChanges, lookUpData.targets) : targetString,
            'customer': customerHistory.length > 0 ? setChangedValues(customerHistory, customerChanges, lookUpData.customers) : customerString,
            'sub-customer': subCustomerHistory.length > 0 ? setChangedValues(subCustomerHistory, subCustomerChanges, lookUpData.subCustomers) : subCustomerString,
            'goal': goalHistory.length > 0 ? setChangedValues(goalHistory, goalChanges, lookUpData.goals) : goalString,
            'timing': timingHistory.length > 0 ? setChangedValues(timingHistory, timingChanges, lookUpData.timings) : timingString,
            'priority': priorityHistory.length > 0 ? setChangedValues(priorityHistory, priorityChanges, lookUpData.priorities) : priorityString,
            'nature': natureHistory.length > 0 ? setChangedValues(natureHistory, natureChanges, lookUpData.natures) : natureString,
            'investment mix': investmentHistory.length > 0 ? setChangedValues(investmentHistory, investmentChanges, lookUpData.investmentMixes) : investmentString,
            'mandatory': mandatoryHistory.length > 0 ? setChangedValues(mandatoryHistory, mandatoryChanges, lookUpData.mandatories) : mandatoryString,
            'methodology': methodologyHistory.length > 0 ? setChangedValues(methodologyHistory, methodologyChanges, lookUpData.methodologies) : methodologyString,
            'digital': digitalHistory.length > 0 ? setChangedValues(digitalHistory, digitalChanges, lookUpData.digitals) : digitalString,
            'project life': prLifeHistory.length > 0 ? setChangedValues(prLifeHistory, prLifeChanges, lookUpData.projectLives) : prLivesString,
            'project status': prStatusHistory.length > 0 ? setChangedValues(prStatusHistory, prStatusChanges, lookUpData.projectStatus) : prStatusString,
            'portfolio mix': portfolioHistory.length > 0 ? setChangedValues(portfolioHistory, portfolioChanges, lookUpData.portfolioMixes) : portfolioString,
            'responsibility center': responsibilityHistory.length > 0 ? setChangedValues(responsibilityHistory, responsibilityChanges, lookUpData.responsibilityCenters) : responsibilityString,
            'isLocked': isLockedHistory.length > 0 ? setChangedValues(isLockedHistory, isLockedChanges) : project.isLocked,
            'project approval': prApprovalHistory.length > 0 ? setChangedValues(prApprovalHistory, prApprovalChanges, lookUpData.projectApprovals) : prApprovalString,
            'project phase': prPhaseHistory.length > 0 ? setChangedValues(prPhaseHistory, prPhaseChanges, lookUpData.projectPhases) : prPhaseString,
            'rebilling': rebillingHistory.length > 0 ? setChangedValues(rebillingHistory, rebillingChanges, lookUpData.rebillings, "Rebilling") : rebillingString,
						'progress': progressHistory.length > 0 ? setChangedValues(progressHistory, progressChanges) : project.progress,
            'estimation': estimationHistory.length > 0 ? setChangedValues(estimationHistory, estimationChanges) : project.estimation,
            'project ko': prKOHistory.length > 0 ? setChangedValues(prKOHistory, prKOChanges) : project.projectKO,
            'connected costs': connectedCostsHistory.length > 0 ? setChangedValues(connectedCostsHistory, connectedCostsChanges) : project.connectedCosts,
            'h/w connected investments': hwInvestmentsHistory.length > 0 ? setChangedValues(hwInvestmentsHistory, hwInvestmentsChanges) : project.hardwareConnectedInvestments,
            'l01': l01History.length > 0 ? setChangedValues(l01History, l01Changes) : project.l01,
            'l01-d1': l01D1History.length > 0 ? setChangedValues(l01D1History, l01D1Changes) : project.l01D1,
            'l01-d2': l01D2History.length > 0 ? setChangedValues(l01D2History, l01D2Changes) : project.l01D2,
            'l01-d3': l01D3History.length > 0 ? setChangedValues(l01D3History, l01D3Changes) : project.l01D3,
            'l03': l03History.length > 0 ? setChangedValues(l03History, l03Changes) : project.l03,
            'l03-d1': l03D1History.length > 0 ? setChangedValues(l03D1History, l03D1Changes) : project.l03D1,
            'l03-d2': l03D2History.length > 0 ? setChangedValues(l03D2History, l03D2Changes) : project.l03D2,
            'l03-d3': l03D3History.length > 0 ? setChangedValues(l03D3History, l03D3Changes) : project.l03D3,
            'l06': l06History.length > 0 ? setChangedValues(l06History, l06Changes) : project.l06,
            'l06-d1': l06D1History.length > 0 ? setChangedValues(l06D1History, l06D1Changes) : project.l06D1,
            'l06-d2': l06D2History.length > 0 ? setChangedValues(l06D2History, l06D2Changes) : project.l06D2,
            'l06-d3': l06D3History.length > 0 ? setChangedValues(l06D3History, l06D3Changes) : project.l06D3,
            'l12': l12History.length > 0 ? setChangedValues(l12History, l12Changes) : project.l12,
            'l12-d1': l12D1History.length > 0 ? setChangedValues(l12D1History, l12D1Changes) : project.l12D1,
            'l12-d2': l12D2History.length > 0 ? setChangedValues(l12D2History, l12D2Changes) : project.l12D2,
            'l12-d3': l12D3History.length > 0 ? setChangedValues(l12D3History, l12D3Changes) : project.l12D3,
            'commitment': commitmentHistory.length > 0 ? setChangedValues(commitmentHistory, commitmentChanges) : project.committment,
            'actual': actualHistory.length > 0 ? setChangedValues(actualHistory, actualChanges) : project.actual,
            'notes': notesHistory.length > 0 ? setChangedValues(notesHistory, notesChanges) : project.notes,
            'release date': releaseDateHistory.length > 0 ? setChangedValues(releaseDateHistory, releaseDateChanges, lookUpData.releaseDates, "Release Date") : releaseDateString,
						'last modified date': updateDateLocal,
            'last modified by': change.doerFullName,
            'changed': change,
          });
        });
      }

      setRowData(projectsData);
    }
  }, [project, lookUpData])

  const [rowData, setRowData] = useState(null);

  useEffect(() => {
    if (rowData !== null){
      const allFieldsLabels = document.querySelectorAll('.ag-column-select-column-label');
      const changedFieldLabel = allFieldsLabels && Array.from(allFieldsLabels).filter(x => x.innerText === "Changed");

      if (changedFieldLabel && changedFieldLabel.length > 0)
        changedFieldLabel[0].parentElement.style.display = "none";
    }
  }, [rowData])

  const [sideBar, setSideBar] = useState({
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel'
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel'
      }
    ],
    position: 'left'
  });

  function dateComparator(date1, date2) {
    const date1Number = dateConverter(date1);
    const date2Number = dateConverter(date2);

    if (date1Number === null && date2Number === null)
      return 0;

    if (date1Number === null)
      return -1;

    if (date2Number === null)
      return 1;

    return date1Number - date2Number;
  }

  function dateConverter(date) {
    if (date === undefined || date === null)
      return null;

    const year = date.split(" ")[0].split("/")[2];
    const month = date.split(" ")[0].split("/")[1];
    const day = date.split(" ")[0].split("/")[0];
    const hours = date.split(" ")[1].split(":")[0];
    const minutes = date.split(" ")[1].split(":")[1];
    const seconds = date.split(" ")[1].split(":")[2];

    return new Date(year, month, day, hours, minutes, seconds);
  }

  function clickHandler() {
    setIsDialog(true);
    getProjectAsync(props.selectedProject[0].id);
  }

  function onSelectionChanged(){
    const selectedLogs = gridApi.getSelectedRows();
    setSelectedLogs(selectedLogs);
  };

  async function RestoreProject(selectedLog){
    setRestoredProjectAsync(selectedLog)
    setIsDialog(false);
  }

  return (
    <>
      <Button
        color="primary"
        size="small"
        variant="contained"
        style={{ marginRight: '15px', fontSize: '11px' }}
        onClick={clickHandler}
        disabled={
          !props.selectedProject ||
          props.selectedProject.length !== 1 ||
          !props.selectedProject[0].id
        }
      >Logs</Button>
      <Dialog
        open={isDialog}
        onClose={() => closeDialog()}
        aria-labelledby="form-dialog-title"
      >
        <div className="ag-theme-balham" style={{ height: '100%', overflow: 'hidden' }}>
          <Button
            color="primary"
            size="small"
            variant="contained"
            style={{ margin: 20, fontSize: '11px' }}
            onClick={async () => await RestoreProject(selectedLogs[0])}
            disabled={
              props &&
              props.isUserInRoles([ApplicationRoles.Owner]) &&
              props.selectedProject && props.selectedProject[0] &&
              props.currentUser.externalKey === props.selectedProject[0].ownerKey &&
              !props.selectedProject[0].isLocked &&
              props.readOnlyMode && !props.readOnlyMode.value &&
              props.currentSession && props.currentSession.isActive &&
              selectedLogs && selectedLogs.length === 1 ? false : true
            }
          >Restore project</Button>
          <div className={classes.gridContainer}>
          <AgGridReact
            defaultColDef={defaultColDef}
            columnDefs={columnDefs}
            rowDeselection={true}
            rowData={rowData}
            animateRows={true}
            suppressRowClickSelection={true}
            enableRangeSelection={true}
            enableFillHandle={true}
            sideBar={sideBar}
            onGridReady={params => {
              gridColumnApi = params.columnApi;
              gridApi = params.api;
              gridApi.showLoadingOverlay();
            }}
            suppressColumnVirtualisation={true}
            multiSortKey={'ctrl'}
            rowSelection="single"
            onSelectionChanged={onSelectionChanged}
          />
          </div>
        </div>
      </Dialog>
    </>
  );
}